'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsSidebarExpanded } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getNodePositions } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getInpageModulesInsideLayoutSections, getInpageModulesOutsideContainers, getInpageModulesInsideFlexColumns } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getSelectedItemId, getIsAnythingSelected } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getGlobalGroupInfo, getGlobalPartialInfo } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import FlexColumn from 'InpageEditorUI/components/FlexColumn';
import WidgetWrapperContainer from 'InpageEditorUI/js/containers/WidgetWrapperContainer';
import GlobalContentEditor from 'InpageEditorUI/components/GlobalContentEditor';
import { getModuleElement } from 'InpageEditorUI/lib/dom';
import { getScopes, getUserId } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getContainers, getEmbedInfoAsJsObject } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { Set as ImmutableSet } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class AllWidgetEditorsContainer extends Component {
  constructor(props) {
    super(props);
    this.renderReactWidgetEditorWrapper = this.renderReactWidgetEditorWrapper.bind(this);
    this.renderReactGlobalContentEditor = this.renderReactGlobalContentEditor.bind(this);
    this.renderReactFlexColumn = this.renderReactFlexColumn.bind(this);
    this.updateCurrentDropTarget = this.updateCurrentDropTarget.bind(this);
    this.generateMissingModuleIdSet = this.generateMissingModuleIdSet.bind(this);
    this.checkIfModuleIsMissing = this.checkIfModuleIsMissing.bind(this);
    this.state = {
      missingModulesSet: this.generateMissingModuleIdSet()
    };
  }
  updateCurrentDropTarget(dropIndex) {
    this.setState({
      currentTargetDropIndex: dropIndex
    });
  }
  generateMissingModuleIdSet() {
    const {
      moduleMissingErrors
    } = this.props;
    return ImmutableSet(moduleMissingErrors);
  }
  checkIfModuleIsMissing(module) {
    const {
      missingModulesSet
    } = this.state;
    const id = module.module_id || module.widget_name || module.body && module.body.widget_name;
    if (id) {
      return missingModulesSet.includes(id.toString());
    }
    return false;
  }
  renderReactWidgetEditorWrapper(widget) {
    const {
      gates,
      bus,
      currentInpageMode,
      selectedItemid,
      isAnythingSelected,
      highlightedWidgetId,
      scrollToModuleId,
      renderLanguage,
      hasUndoRedoAccess,
      selectedModuleName,
      sidebarIsExpanded,
      tellParentToHideModuleMenu,
      shouldShowFakeWidgetEditors,
      updateNodePositions,
      layoutSectionHoverPositionsClearedAndFrozen,
      layoutSectionHoverPositionsThawed,
      scopes,
      userId
    } = this.props;
    const isInGroupOrPartial = !!widget.global_group_path || !!widget.global_partial_path;
    if (!this.checkIfModuleIsMissing(widget) && !isInGroupOrPartial) {
      return WidgetWrapperContainer({
        widget,
        gates,
        bus,
        currentInpageMode,
        selectedItemid,
        isAnythingSelected,
        renderLanguage,
        hasUndoRedoAccess,
        highlightedWidgetId,
        scrollToModuleId,
        selectedModuleName,
        sidebarIsExpanded,
        tellParentToHideModuleMenu,
        shouldShowFakeWidgetEditors,
        updateNodePositions,
        layoutSectionHoverPositionsClearedAndFrozen,
        layoutSectionHoverPositionsThawed,
        scopes,
        userId
      });
    } else {
      return null;
    }
  }
  renderReactGlobalContentEditor(globalGroup, type) {
    const {
      selectedItemid,
      highlightedWidgetId
    } = this.props;
    return /*#__PURE__*/_jsx(GlobalContentEditor, {
      selectedItemid: selectedItemid,
      globalGroup: globalGroup,
      highlightedWidgetId: highlightedWidgetId,
      type: type
    }, globalGroup.path);
  }
  renderReactFlexColumn(immutableContainer) {
    const {
      gates,
      bus,
      currentInpageMode,
      selectedItemid,
      highlightedWidgetId,
      isAnythingSelected,
      scrollToModuleId,
      inpageModulesInsideContainers,
      renderLanguage,
      hasUndoRedoAccess,
      tellParentToHideModuleMenu,
      selectedModuleName,
      shouldShowFakeWidgetEditors,
      sidebarIsExpanded,
      updateNodePositions,
      updateFlexColumnContents,
      startDraggingFromFlexColumn,
      endDraggingFromFlexColumn,
      layoutSectionHoverPositionsClearedAndFrozen,
      layoutSectionHoverPositionsThawed,
      isDragging,
      widgetBeingDraggedIndex,
      widgetBeingDraggedParentContainer,
      scopes,
      userId
    } = this.props;
    const {
      currentTargetDropIndex
    } = this.state;
    const container = immutableContainer.toJSON();
    const containerElement = getModuleElement(immutableContainer);
    return /*#__PURE__*/_jsx(FlexColumn, {
      container: container,
      containerElement: containerElement,
      inpageModulesInsideContainers: inpageModulesInsideContainers,
      updateFlexColumnContents: updateFlexColumnContents,
      updateCurrentDropTarget: this.updateCurrentDropTarget,
      currentTargetDropIndex: currentTargetDropIndex,
      isDragging: isDragging,
      widgetBeingDraggedIndex: widgetBeingDraggedIndex,
      widgetBeingDraggedParentContainer: widgetBeingDraggedParentContainer,
      startDraggingFromFlexColumn: startDraggingFromFlexColumn,
      endDraggingFromFlexColumn: endDraggingFromFlexColumn,
      layoutSectionHoverPositionsClearedAndFrozen: layoutSectionHoverPositionsClearedAndFrozen,
      layoutSectionHoverPositionsThawed: layoutSectionHoverPositionsThawed,
      bus: bus,
      gates: gates,
      selectedItemid: selectedItemid,
      highlightedWidgetId: highlightedWidgetId,
      isAnythingSelected: isAnythingSelected,
      currentInpageMode: currentInpageMode,
      scrollToModuleId: scrollToModuleId,
      sidebarIsExpanded: sidebarIsExpanded,
      renderLanguage: renderLanguage,
      hasUndoRedoAccess: hasUndoRedoAccess,
      selectedModuleName: selectedModuleName,
      tellParentToHideModuleMenu: tellParentToHideModuleMenu,
      updateNodePositions: updateNodePositions,
      shouldShowFakeWidgetEditors: shouldShowFakeWidgetEditors,
      scopes: scopes,
      userId: userId
    }, container.name);
  }
  render() {
    const {
      allContainers,
      globalGroups,
      globalPartials,
      embedInfo,
      inpageModulesInsideLayoutSections,
      inpageModulesOutsideContainers
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [inpageModulesOutsideContainers.map(this.renderReactWidgetEditorWrapper), Object.values(allContainers).map(this.renderReactFlexColumn), inpageModulesInsideLayoutSections.map(this.renderReactWidgetEditorWrapper), Object.values(globalGroups).map(group => this.renderReactGlobalContentEditor(group, 'group')), Object.values(globalPartials).map(partial => this.renderReactGlobalContentEditor(partial, 'partial')), Object.values(embedInfo).map(embed => this.renderReactGlobalContentEditor(embed, 'embed'))]
    });
  }
}
AllWidgetEditorsContainer.propTypes = {
  allContainers: PropTypes.object.isRequired,
  globalGroups: PropTypes.object.isRequired,
  globalPartials: PropTypes.object.isRequired,
  embedInfo: PropTypes.object.isRequired,
  inpageModulesInsideLayoutSections: PropTypes.array.isRequired,
  inpageModulesInsideContainers: PropTypes.array.isRequired,
  inpageModulesOutsideContainers: PropTypes.array.isRequired,
  gates: PropTypes.array.isRequired,
  bus: PropTypes.object.isRequired,
  currentInpageMode: PropTypes.string.isRequired,
  selectedItemid: PropTypes.string,
  highlightedWidgetId: PropTypes.string,
  isAnythingSelected: PropTypes.bool.isRequired,
  scrollToModuleId: PropTypes.string,
  renderLanguage: PropTypes.string.isRequired,
  hasUndoRedoAccess: PropTypes.bool.isRequired,
  tellParentToHideModuleMenu: PropTypes.func.isRequired,
  selectedModuleName: PropTypes.string,
  shouldShowFakeWidgetEditors: PropTypes.func.isRequired,
  updateNodePositions: PropTypes.func.isRequired,
  sidebarIsExpanded: PropTypes.bool,
  updateFlexColumnContents: PropTypes.func.isRequired,
  startDraggingFromFlexColumn: PropTypes.func.isRequired,
  endDraggingFromFlexColumn: PropTypes.func.isRequired,
  layoutSectionHoverPositionsClearedAndFrozen: PropTypes.func.isRequired,
  layoutSectionHoverPositionsThawed: PropTypes.func.isRequired,
  isDragging: PropTypes.bool,
  widgetBeingDraggedParentContainer: PropTypes.string,
  widgetBeingDraggedIndex: PropTypes.number,
  scopes: PropTypes.array.isRequired,
  userId: PropTypes.number.isRequired,
  moduleMissingErrors: PropTypes.array.isRequired
};
const mapStateToProps = state => {
  return {
    globalGroups: getGlobalGroupInfo(state),
    globalPartials: getGlobalPartialInfo(state),
    embedInfo: getEmbedInfoAsJsObject(state),
    inpageModulesInsideLayoutSections: getInpageModulesInsideLayoutSections(state),
    inpageModulesInsideContainers: getInpageModulesInsideFlexColumns(state),
    inpageModulesOutsideContainers: getInpageModulesOutsideContainers(state),
    selectedItemid: getSelectedItemId(state),
    isAnythingSelected: getIsAnythingSelected(state),
    nodePositions: getNodePositions(state),
    sidebarIsExpanded: getIsSidebarExpanded(state),
    scopes: getScopes(state),
    userId: getUserId(state),
    allContainers: getContainers(state)
  };
};
export default connect(mapStateToProps)(AllWidgetEditorsContainer);